import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationsService } from 'angular2-notifications';
import { ApiService } from '../../../../utils/services/api.service';
import { DialogModalComponent } from '../../../../shared/dialog-modal/dialog-modal.component';
import {
  ANNOUNCEMENT_INCOMPLETE_CODE,
  AnnouncementRow,
  categoryLabel,
  formatAnnouncementDate
} from '../whats-new';

@Component({
  selector: 'app-whats-new-list',
  templateUrl: './whats-new-list.component.html',
  styleUrls: ['./whats-new-list.component.css']
})
export class WhatsNewListComponent implements OnInit {
  public announcements: AnnouncementRow[] = null;
  public busyId: number = null;
  public categoryLabel = categoryLabel;
  public formatDate = formatAnnouncementDate;

  constructor(
    private apiService: ApiService,
    private notifications: NotificationsService,
    private modalService: NgbModal,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.fetchAnnouncements();
  }

  fetchAnnouncements() {
    this.apiService.getAnnouncements().subscribe(res => {
      this.announcements = res.data;
    }, () => {
      this.announcements = [];
      this.notifications.error('Hata', 'Duyurular yüklenemedi.');
    });
  }

  stateText(row: AnnouncementRow): string {
    if (row.state === 'Scheduled') {
      return `Planlı (${formatAnnouncementDate(row.publishDate)})`;
    }
    return row.state === 'Published' ? 'Yayında' : 'Taslak';
  }

  feedbackText(row: AnnouncementRow): string {
    const summary = row.feedbackSummary;
    const notes = summary.notes ? ` · ${summary.notes} not` : '';
    return `${summary.yes} Evet · ${summary.no} Hayır${notes}`;
  }

  hasFeedback(row: AnnouncementRow): boolean {
    return row.feedbackSummary.yes + row.feedbackSummary.no > 0;
  }

  toggleStatus(row: AnnouncementRow) {
    const publish = row.status === 'Draft';
    this.busyId = row.id;
    this.apiService.changeAnnouncementStatus(row.id, publish ? 'Published' : 'Draft').subscribe(() => {
      this.busyId = null;
      this.notifications.success(publish ? 'Duyuru yayınlandı' : 'Duyuru yayından kaldırıldı');
      this.fetchAnnouncements();
    }, error => {
      this.busyId = null;
      if (publish && error.error && error.error.code === ANNOUNCEMENT_INCOMPLETE_CODE) {
        this.router.navigate(['/whats-new', row.id], { queryParams: { publish: 1 } });
        return;
      }
      this.notifications.error('Hata', 'İşlem başarısız!');
    });
  }

  confirmDelete(row: AnnouncementRow) {
    const dialogRef = this.modalService.open(DialogModalComponent, { size: 'sm' });
    dialogRef.componentInstance.modalTitle = 'Duyuru silinsin mi?';
    dialogRef.componentInstance.modalText = `“${row.title}” duyurusu ve geri bildirimleri kalıcı olarak silinir.`;
    dialogRef.componentInstance.confirmText = 'Sil';
    dialogRef.result.then(result => {
      if (result && result.type === 'YES') {
        this.deleteAnnouncement(row);
      }
    }, () => {
    });
  }

  private deleteAnnouncement(row: AnnouncementRow) {
    this.busyId = row.id;
    this.apiService.deleteAnnouncement(row.id).subscribe(() => {
      this.busyId = null;
      this.notifications.success('Duyuru silindi');
      this.fetchAnnouncements();
    }, () => {
      this.busyId = null;
      this.notifications.error('Hata', 'İşlem başarısız!');
    });
  }
}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/main/pages/whats-new/whats-new-list/whats-new-list.component.ts